/**
 * Feature flags client-side per disabilitare temporaneamente intere feature
 * senza rimuovere il codice.
 *
 * Pattern d'uso:
 *   import { AUDIO_TRANSCRIPTION_LEGACY_ENABLED } from '@/lib/featureFlags';
 *   if (!AUDIO_TRANSCRIPTION_LEGACY_ENABLED) return null;
 *   // o nel JSX: {AUDIO_TRANSCRIPTION_LEGACY_ENABLED && <Button>Trascrivi</Button>}
 */

/**
 * Disabilita 8 feature di trascrizione audio basate su OpenAI Whisper
 * (WhatsApp voice notes, call recordings, screen recordings, team chat audio,
 *  calendar audio, AI task gen from audio, WhatsApp agent analysis, project
 *  recordings transcription).
 *
 * **NON impatta**:
 * - Meeting transcription (Deepgram via `deepgram-transcribe` edge function),
 *   che resta attiva — usata principalmente da Vexa bot per Google Meet/Zoom.
 *
 * **Motivo**: rimozione OpenAI come sub-processor USA per cutover GDPR completo
 * post-migrazione EU del 15 mag 2026. Eliminare 1 DPA + semplificare Privacy
 * Policy. Riattivare quando le sorgenti Whisper saranno migrate a Deepgram.
 *
 * **Riattivazione**: cambia il valore a `true` qui sotto. Nessuna altra modifica
 * di codice richiesta.
 */
export const AUDIO_TRANSCRIPTION_LEGACY_ENABLED = false;

/**
 * Trascrizione dei vocali WhatsApp nella chat (30/10/2026): riattivata da sola, perche' dal 27/10/2026 i vocali
 * li trascrive il core sul nostro server, senza OpenAI Whisper. Le altre sorgenti coperte da
 * AUDIO_TRANSCRIPTION_LEGACY_ENABLED restano spente.
 */
export const WHATSAPP_AUDIO_TRANSCRIPTION_ENABLED = true;
